import {makeHttpEndpoint} from "./index";
import axios from "axios";


export const getAnswerSummaryForSurvey = async(id: string) => {
    return await axios.get(makeHttpEndpoint(`/answersummary/${id}`), {withCredentials: true})
}